import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import exportingInit from "highcharts/modules/exporting";
import wordCloud from "highcharts/modules/wordcloud";
import noDataToDisplay from "highcharts/modules/no-data-to-display";

import { Auth0Plugin } from "../src/components/auth/index.js";
import vuetify from "@/plugins/vuetify.ts";

Vue.use(Vuex);
Vue.use(Auth0Plugin, {
  onRedirectCallback: (appState: any) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
});
exportingInit(Highcharts);
highchartsMore(Highcharts);
wordCloud(Highcharts);
noDataToDisplay(Highcharts);

Vue.use(HighchartsVue);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
